import { Fragment, PureComponent, ReactNode } from 'react';
import ToothImage from './ToothImage';
import RestSurfaces from './RestSurfaces';
import SixthSurface from './SixthSurface';
import ToothNumber from './ToothNumber';
import SeventhSurface from './SeventhSurface';
import { KeyToSetObject } from '../Chart';

interface Props {
    tooth: string;
    selectTeeth: (teeth: string) => void;
    examinations?: string[];
    isSelected: boolean;
    selectSurface: (teeth: string, surface: number) => void;
    firstSurfaceName: string;
    secondSurfaceName: string;
    thirdSurfaceName: string;
    fourthSurfaceName: string;
    fifthSurfaceName: string;
    sixthSurfaceName: string;
    seventhSurfaceName: string;
    isFirstSurfaceSelected: boolean;
    isSecondSurfaceSelected: boolean;
    isThirdSurfaceSelected: boolean;
    isFourthSurfaceSelected: boolean;
    isFifthSurfaceSelected: boolean;
    isSixthSurfaceSelected: boolean;
    isSeventhSurfaceSelected: boolean;
    isForLowerTeeth?: boolean;
    selectedMultiTeeth: KeyToSetObject;
    selectMultiTeeth: (teeth: string, surface?: number) => void;
    isSelectedMultiTeethArray: boolean;
    showRightBorder?: boolean;
}

class ToothComponent extends PureComponent<Props> {
    selectTeeth = (teeth: string): void => {
        const { isSelectedMultiTeethArray, selectMultiTeeth, selectTeeth } = this.props;
        if (isSelectedMultiTeethArray) {
            selectMultiTeeth(teeth);
        } else {
            selectTeeth(teeth);
        }
    };

    selectSurface = (teeth: string, surface: number): void => {
        const { isSelectedMultiTeethArray, selectMultiTeeth, selectSurface } = this.props;
        if (isSelectedMultiTeethArray) {
            selectMultiTeeth(teeth, surface);
        } else {
            selectSurface(teeth, surface);
        }
    };

    render(): ReactNode {
        const {
            tooth,
            examinations,
            isSelected,
            firstSurfaceName,
            secondSurfaceName,
            thirdSurfaceName,
            fourthSurfaceName,
            fifthSurfaceName,
            sixthSurfaceName,
            seventhSurfaceName,
            isFirstSurfaceSelected,
            isSecondSurfaceSelected,
            isThirdSurfaceSelected,
            isFourthSurfaceSelected,
            isFifthSurfaceSelected,
            isSixthSurfaceSelected,
            isSeventhSurfaceSelected,
            isForLowerTeeth,
            selectedMultiTeeth,
            selectMultiTeeth,
            isSelectedMultiTeethArray,
            showRightBorder,
        } = this.props;
        const { selectTeeth, selectSurface } = this;

        return (
            <Fragment>
                <div className="py-8 teeth-container relative flex flex-col items-center hover:bg-darwin-accent-bright-blue-100 rounded-4">
                    {isForLowerTeeth ? (
                        <Fragment>
                            <RestSurfaces
                                tooth={tooth}
                                selectSurface={selectSurface}
                                firstSurfaceName={firstSurfaceName}
                                secondSurfaceName={secondSurfaceName}
                                thirdSurfaceName={thirdSurfaceName}
                                fourthSurfaceName={fourthSurfaceName}
                                fifthSurfaceName={fifthSurfaceName}
                                isFirstSurfaceSelected={isFirstSurfaceSelected}
                                isSecondSurfaceSelected={isSecondSurfaceSelected}
                                isThirdSurfaceSelected={isThirdSurfaceSelected}
                                isFourthSurfaceSelected={isFourthSurfaceSelected}
                                isFifthSurfaceSelected={isFifthSurfaceSelected}
                            />
                            <SixthSurface
                                tooth={tooth}
                                sixthSurfaceName={sixthSurfaceName}
                                isSixthSurfaceSelected={isSixthSurfaceSelected}
                                selectSurface={selectSurface}
                                isForLowerTeeth
                            />
                            <SeventhSurface
                                tooth={tooth}
                                seventhSurfaceName={seventhSurfaceName}
                                isSeventhSurfaceSelected={isSeventhSurfaceSelected}
                                selectSurface={selectSurface}
                                isForLowerTeeth
                            />
                            <ToothNumber
                                tooth={tooth}
                                isSelected={isSelected}
                                isForLowerTeeth
                                selectedMultiTeeth={selectedMultiTeeth}
                                selectMultiTeeth={selectMultiTeeth}
                                isSelectedMultiTeethArray={isSelectedMultiTeethArray}
                            />
                            <ToothImage
                                tooth={tooth}
                                selectTeeth={selectTeeth}
                                examinations={!isSelectedMultiTeethArray ? examinations : undefined}
                                isForLowerTeeth
                                isSelectedMultiTeethArray={isSelectedMultiTeethArray}
                            />
                        </Fragment>
                    ) : (
                        <Fragment>
                            <ToothImage
                                tooth={tooth}
                                selectTeeth={selectTeeth}
                                examinations={!isSelectedMultiTeethArray ? examinations : undefined}
                                isSelectedMultiTeethArray={isSelectedMultiTeethArray}
                            />
                            <ToothNumber
                                tooth={tooth}
                                isSelected={isSelected}
                                selectedMultiTeeth={selectedMultiTeeth}
                                selectMultiTeeth={selectMultiTeeth}
                                isSelectedMultiTeethArray={isSelectedMultiTeethArray}
                            />
                            <SeventhSurface
                                tooth={tooth}
                                seventhSurfaceName={seventhSurfaceName}
                                isSeventhSurfaceSelected={isSeventhSurfaceSelected}
                                selectSurface={selectSurface}
                            />
                            <SixthSurface
                                tooth={tooth}
                                sixthSurfaceName={sixthSurfaceName}
                                isSixthSurfaceSelected={isSixthSurfaceSelected}
                                selectSurface={selectSurface}
                            />
                            <RestSurfaces
                                tooth={tooth}
                                selectSurface={selectSurface}
                                firstSurfaceName={firstSurfaceName}
                                secondSurfaceName={secondSurfaceName}
                                thirdSurfaceName={thirdSurfaceName}
                                fourthSurfaceName={fourthSurfaceName}
                                fifthSurfaceName={fifthSurfaceName}
                                isFirstSurfaceSelected={isFirstSurfaceSelected}
                                isSecondSurfaceSelected={isSecondSurfaceSelected}
                                isThirdSurfaceSelected={isThirdSurfaceSelected}
                                isFourthSurfaceSelected={isFourthSurfaceSelected}
                                isFifthSurfaceSelected={isFifthSurfaceSelected}
                            />
                        </Fragment>
                    )}
                </div>
                {showRightBorder && (
                    <div className="h-full border-r border-darwin-neutral_new-200 mx-4"></div>
                )}
            </Fragment>
        );
    }
}

export default ToothComponent;
